// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor_anchor__14ukD","disabled":"anchor_disabled__1ltns","transitions":"anchor_transitions__8hOMx","smallFontSize":"anchor_smallFontSize__3_Hpu"};